// extracted by mini-css-extract-plugin
export default {"form":"ElectronicInvoice_form__vPaja","form-box":"ElectronicInvoice_form-box__35a5s","tax-item":"ElectronicInvoice_tax-item__93YUU","add-tax":"ElectronicInvoice_add-tax__4dm8g"};